import {
  ComponentPropsWithoutRef,
  forwardRef,
  useImperativeHandle,
  useRef,
} from "react";
import { Button } from "react-bootstrap";
import messages from "messages";
// components
import ModalLayout from "components/modal/modal-layout/ModalLayout";
import AvailableTimePeriodEditor from "../../../available-time-period-editor/AvailableTimePeriodEditor";

// styles
import styles from "./styles.module.scss";
import { AmplitudePageName } from "utils/amplitude";

type Props = ComponentPropsWithoutRef<typeof ModalLayout> & {
  value: ParsedAvailableTimePeriod;
  onApply: () => void;
  onChange: (arg: ParsedAvailableTimePeriod) => void;
  analyticsPageName: AmplitudePageName;
};

/**
 * renders UI to create one available time period / schedule
 */
const ForwardedScheduleCreator = forwardRef<
  Pick<HTMLFormElement, "checkValidity" | "reset">,
  Props
>(function ScheduleCreator(
  { show, value, onApply, onChange, analyticsPageName, onHide, ...rest },
  ref,
) {
  const inputRefs = useRef<
    (Pick<HTMLFormElement, "checkValidity" | "reset"> | null)[]
  >([]);

  useImperativeHandle(ref, () => ({
    checkValidity: () => {
      const validities = inputRefs.current.map((el) => {
        if (!el) {
          return true;
        }

        return el.checkValidity();
      });

      return validities.every((el) => el);
    },
    reset: () =>
      inputRefs.current.forEach((el) => {
        if (!el) {
          return true;
        }
        return el.reset();
      }),
  }));
  return (
    <ModalLayout
      size={"lg"}
      dialogClassName={styles["schedule-creator__dialog"]}
      headerClass={styles["schedule-creator__header"]}
      bodyClass={styles["schedule-creator__body"]}
      footerClass={styles["schedule-creator__footer"]}
      showHeaderDivider={true}
      show={show}
      Header={messages.createSchedule}
      onHide={onHide}
      Footer={
        <>
          <Button
            className={styles["schedule-creator__footer-btn"]}
            variant={"outline-primary"}
            onClick={onHide}
          >
            {messages.cancel}
          </Button>
          <Button
            className={styles["schedule-creator__footer-btn"]}
            variant={"primary"}
            onClick={onApply}
          >
            {messages.add}
          </Button>
        </>
      }
      {...rest}
    >
      <AvailableTimePeriodEditor
        ref={(el) => {
          inputRefs.current[0] = el;
        }}
        value={value}
        onApply={onChange}
        analyticsPageName={analyticsPageName}
      />
    </ModalLayout>
  );
});

export default ForwardedScheduleCreator;
